// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarNavMenu_root__7kX6P"};